import { i18next } from '@frontend/i18n';
import { RegisterTerminalModalJustifiSteps, RegisterTerminalModalStripeSteps } from './hooks';
import { RegisterTerminalModalType } from './types';

export const STRIPE_REGISTER_TERMINAL_STEPS_TITLES = {
  [RegisterTerminalModalStripeSteps.InstallBattery]: {
    title: i18next.t('Power Up Terminal', { ns: 'payments' }),
    heading: i18next.t('Power Up Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.PlugInTerminal]: {
    title: i18next.t('Power Up Terminal', { ns: 'payments' }),
    heading: i18next.t('Power Up Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.TurnTerminalOn]: {
    title: i18next.t('Power Up Terminal', { ns: 'payments' }),
    heading: i18next.t('Power Up Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.ConnectToNetwork]: {
    title: i18next.t('Connect to Network', { ns: 'payments' }),
    heading: i18next.t('Connect to Network', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.GeneratePairingCode]: {
    title: i18next.t('Register Terminal', { ns: 'payments' }),
    heading: i18next.t('Register Your Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalStripeSteps.PairYourTerminal]: {
    title: i18next.t('Register Terminal', { ns: 'payments' }),
    heading: i18next.t('Register Your Terminal', { ns: 'payments' }),
  },
};

export const JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES = {
  [RegisterTerminalModalJustifiSteps.PreCheck]: {
    title: i18next.t('Power Up Terminal', { ns: 'payments' }),
    heading: i18next.t('Power Up Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.TurnOnTerminal]: {
    title: i18next.t('Power Up Terminal', { ns: 'payments' }),
    heading: i18next.t('Power Up Terminal', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.ConnectToWifiStep1]: {
    title: i18next.t('Connect to Network', { ns: 'payments' }),
    heading: i18next.t('Connect Terminal to WiFi', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.ConnectToWifiStep2]: {
    title: i18next.t('Connect to Network', { ns: 'payments' }),
    heading: i18next.t('Connect Terminal to WiFi', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.ConnectToWifiStep3]: {
    title: i18next.t('Connect to Network', { ns: 'payments' }),
    heading: i18next.t('Connect Terminal to WiFi', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.IncorrectPassword]: {
    title: i18next.t('Connect to Network', { ns: 'payments' }),
    heading: i18next.t('Connect Terminal to WiFi', { ns: 'payments' }),
  },
  [RegisterTerminalModalJustifiSteps.GenrateDeviceId]: {
    title: i18next.t('Register Terminal', { ns: 'payments' }),
    heading: i18next.t('Register Your Terminal', { ns: 'payments' }),
  },
};

export interface StepperStep {
  id: string;
  title: string;
}

export const getStepperSteps = (type: RegisterTerminalModalType): StepperStep[] =>
  Object.entries(
    type === 'stripe' ? STRIPE_REGISTER_TERMINAL_STEPS_TITLES : JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES
  ).map(([key, { title }]) => ({
    id: key,
    title,
  }));
